export const Columns = {
    SOLD_DATE: 'SOLD_DATE',
    BUYER: 'BUYER',
    ORDER: 'ORDER',
    QUANTITY: 'QUANTITY',
    BUYING_PRICE: 'BUYING_PRICE',
    PAYMENT_TYPE: 'PAYMENT_TYPE',
    STATUS: 'STATUS',
    ACTIONS: 'ACTIONS'
};
